// extracted by mini-css-extract-plugin
module.exports = {"metro":"Place_metro__SCfRd"};